import { RemoveCircleOutline as RemoveCircleOutlineIcon } from '@mui/icons-material'
import { IconButton, Stack, Tooltip } from '@mui/material'

import { produce } from 'immer'

import { form } from '../../../formState'
import { useTexts } from '../../../hooks/useTexts'

interface Props {
  territoryId: string
  territoryName: string
}

export function Header(props: Props) {
  const { territoryName, territoryId } = props
  const { api, values } = form.useForm()
  const filterValue = values.courierFilter
  const driverIds = values.drivers
  const vehicleIds = values.vehicles
  const texts = useTexts()

  const remove = territoryId => {
    const updatedFilters = filterValue.filter(item => item !== territoryId)

    const updatedVehiclesValue = produce(vehicleIds, draft => {
      delete draft?.[territoryId]
    })

    const updatedDriversValue = produce(driverIds, draft => {
      delete draft?.[territoryId]
    })

    api.batch({
      vehicles: updatedVehiclesValue,
      drivers: updatedDriversValue,
      courierFilter: updatedFilters,
    })
  }

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <form.SectionTitle variant="alternative">{territoryName}</form.SectionTitle>
      <Tooltip title={texts.tooltip.removeTerritory} placement="top">
        <IconButton onClick={() => remove(territoryId)} color="error" size="small">
          <RemoveCircleOutlineIcon />
        </IconButton>
      </Tooltip>
    </Stack>
  )
}
